import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import IndexSection from './components/IndexSection';
import UpdatesSection from './components/UpdatesSection';
import ContactSection from './components/ContactSection';
import RankingSection from './components/RankingSection';
import AppSection from './components/AppSection';
import MediaSection from './components/MediaSection';
import FeaturesSection from './components/FeaturesSection';
import TopicsSection from './components/TopicsSection';
import FAQSection from './components/FAQSection';
import AboutSection from './components/AboutSection';
import CommentsSection from './components/CommentsSection';
import CarouselSection from './components/CarouselSection';
import CardsSection from './components/CardsSection';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <IndexSection />
        <UpdatesSection />
        <ContactSection />
        <RankingSection />
        <AppSection />
        <MediaSection />
        <FeaturesSection />
        <TopicsSection />
        <FAQSection />
        <AboutSection />
        <CommentsSection />
        <CarouselSection />
        <CardsSection />
      </main>
      <Footer />
    </>
  );
}